import script from "./IconPickerIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./IconPickerIndex.vue?vue&type=script&setup=true&lang=js"

import "./IconPickerIndex.vue?vue&type=style&index=0&id=7b7f4aca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7f4aca"]])

export default __exports__